import { InputField, InputOption, InputSelect } from "@sellar-io/components";
import { RETAILER_TYPES } from "../../constants/sellarConstants.shared";
import { useSellarCurrentBusiness } from "../../hooks/useSellarCurrentBusiness.shared";
import { generateFormPath } from "~/utils/formHelpers";
import { BusinessFormApi } from "../business/BusinessFormValues";
import {
  fieldNote,
  getFieldError,
  invalidFieldClassName,
  requiredField,
} from "../business/formValidation";
import { OwnershipType } from "./BuyerBusinessOwnership";
import { fieldName } from "./BuyerFormFragment.shared";

export type BuyerFieldValues = {
  ownershipType: OwnershipType | undefined;
};

export function BuyerFormFragment({
  form,
  path,
}: {
  form: BusinessFormApi;
  path?: string;
}) {
  const { business: userBusiness } = useSellarCurrentBusiness();
  const name = generateFormPath("type", path);

  return (
    <form.Field
      name={fieldName(name)}
      validators={
        !userBusiness?.Supplier ? requiredField("Venue type") : undefined
      }
    >
      {({ state, handleChange, handleBlur }) => {
        const errorMessage = getFieldError(state.meta.errors);

        return (
          <InputField
            label={`Venue type`}
            className={errorMessage ? invalidFieldClassName : undefined}
            note={fieldNote(undefined, errorMessage)}
            containerClassName={
              errorMessage
                ? "border-red-300 focus-within:border-red-500"
                : undefined
            }
          >
            <InputSelect
              name={name}
              value={String(state.value ?? "")}
              onBlur={handleBlur}
              onChange={(event) => handleChange(event.target.value)}
              required={!userBusiness?.Supplier}
            >
              {Object.keys(RETAILER_TYPES).map((key) => (
                <InputOption
                  key={RETAILER_TYPES[key as keyof typeof RETAILER_TYPES].value}
                  value={
                    RETAILER_TYPES[key as keyof typeof RETAILER_TYPES].value
                  }
                >
                  {RETAILER_TYPES[key as keyof typeof RETAILER_TYPES].name}
                </InputOption>
              ))}
            </InputSelect>
          </InputField>
        );
      }}
    </form.Field>
  );
}
